import BaseModel from "../models/BaseModel";
import BaseModelReference from "../models/BaseModelReference";
import type Signal from "../models/Signal";
import type Channel from "../models/Channel";
import { belongsToBundle } from "../models/SignalBundles";
import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";
import { isUiModeExpert, isUiModeProductAdmin } from "../uiMode";
import { sortArrayByProperty } from "../models/utils";
import ObjectReference from "../components/ObjectReference";

export default class SignalTreeViewModel extends TreeViewModel {
  get typedObj(): Signal {
    return this.obj as Signal;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return true;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    const res = new Array<BaseModel>();
    this.typedObj.groupAddresses.sortBy("fullAddress").forEach((a) => {
      const ref = new BaseModelReference({ referencedObject: a }, this.typedObj);
      ref.usefromRefencedTreeviewObject.fullTitle = true;
      ref.usefromRefencedTreeviewObject.titlePostfix = true;
      ref.usefromRefencedTreeviewObject.showChildern = isUiModeExpert();
      res.push(ref);
    });
    return res;
  }

  // getTitlePostfix(): string | JSX.Element {
  //   var res = ` - ${this.typedObj.knxFunctionText}`;
  //   return res;
  // }

  getFullTitle(isExpanded: boolean): string | undefined | JSX.Element {
    const parentName = (this.typedObj.parent?.displayName || "").trim();

    var xName = this.typedObj.displayName.trim();
    xName = xName.replace(parentName, "");

    if (xName != "") xName += " - ";

    let res: any = `${xName}${this.typedObj.knxFunctionText}`;

    const space = "\u00A0"; // no itx

    if (!isExpanded && isUiModeExpert() && this.typedObj.groupAddresses.length > 0) {
      const partnerElements: any = [];
      const groupAddresses = sortArrayByProperty(this.typedObj.groupAddresses.items, "fullAddress");
      groupAddresses.forEach((ga) => {
        partnerElements.push(<ObjectReference obj={ga} />);
      });

      res = (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <div className="nav_C3">{res}</div>
          <div
            className="nav_C4"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginLeft: "10px",
              fontSize: "0.75em",
              color: "gray",
            }}
          >
            {partnerElements}
          </div>
        </div>
      );
    }

    const signalBelongsToBundle = belongsToBundle((this.typedObj.parent as Channel).channelType, this.typedObj);

    if (!signalBelongsToBundle) {
      return (
        <span
          style={{
            color: "grey",
          }}
        >
          {res}
        </span>
      );
    }

    return res;
  }

  allowDrag(): boolean {
    return true;
  }

  allowDrop(event: any): boolean {
    return true;
  }

  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    try {
      const res = this.typedObj.connectWith(obj);
      return new DropResult(res);
    } catch (ex) {}

    return new DropResult(false);
  }
}
